module.exports = __webpack_public_path__ + "98f2ba7f55ac186c82bd175b23c408a1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/styles/img/create_workshop_info/accreditation_mob@3x.jpg
// module id = 645
// module chunks = 0